import i18n from "@/i18n"

function fields() {
  return [
    {
      label: i18n.t('delivery.fields.deliveryNumber'),
      key: 'number',
      isSortable: true,
      isRedirectable: true,
    },
    {
      label: i18n.t('delivery.fields.fleetTaskNumber'),
      key: 'fleet_task.number',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.shippedCustomerName'),
      key: 'shipped_customer.name',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.vendor'),
      key: 'vendor.name',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.originAddress'),
      key: 'origin_address.name',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.destinationAddress'),
      key: 'destination_address.name',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.loadWeight'),
      key: 'load_weight',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.loadVolume'),
      key: 'load_volume',
      isSortable: true,
    },
    {
      label: i18n.t('delivery.fields.reason'),
      key: 'canceled_reason',
    },
  ]
}

export default fields
